export default __webpack_public_path__ + "static/media/328.2aa19efa.png";